<template>
  <div
    class="tag-input-div"
    :style="[
      style,
      {
        flexDirection: layout === TagInputLayout.VERTICAL ? 'column' : 'row',
      },
    ]"
  >
    <p
      class="title-p"
      v-show="showTitle"
      :style="`margin-top: ${
        layout === TagInputLayout.HORIZONTAL ? '10px' : 0
      }`"
    >
      {{ `${required ? "*" : ""}${t("upload.tag")}` }}
    </p>
    <div
      class="flex flex-col gap-8px"
      :style="`min-width: ${width}; max-width: ${maxW}`"
    >
      <div ref="tagInputDivRef" class="input-div" @click="tagInputClick">
        <div class="input-tag-div" ref="inputDivRef">
          <div class="tag-item" v-for="item in tags" :key="item" :title="item">
            <p class="white-nowrap">{{ item }}</p>
            <svg-icon name="icon_purple_close" @click="deleteTag(item)" />
          </div>
          <el-input
            ref="tagInputRef"
            class="tag-input"
            :class="
              !(isTagInputFocus && !isBlurAddTag && tags.length < maxLength) &&
              'hide-tag-input'
            "
            v-model="tag"
            :maxlength="TAG_INPUT_MAX_LENGTH"
            @keyup.enter="addTag"
            @blur="blurAddTag"
            @input="handleInput"
          />
        </div>
        <span class="placeholder-length" ref="placeholderRef">
          <span class="nums">{{
            `${tags ? tags.length : 0}/${maxLength}`
          }}</span>
        </span>
      </div>
      <!-- 推荐标签 -->
      <!-- 由于目前推荐的标签不符合产品要求,暂时隐藏 -->
      <!-- <ul class="recommend-ul" v-if="!!recommendTags && !!recommendTags.length">
        <li
          v-for="item in recommendTags"
          :key="item"
          :alt="item.tag"
          :title="item.tag"
          @click="addRTag(item.tag)"
        >
          <p class="white-nowrap whitespace-pre">
            {{ item.tag }}
          </p>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  TagInputLayout,
  type ITagInputProps,
} from "~/composables/useTagInput/types";
import { onClickOutside } from "@vueuse/core";
import { isValidInput } from "~/composables/useTagInput/index";

const TAG_INPUT_MAX_LENGTH = 50;
const props = withDefaults(defineProps<ITagInputProps>(), {
  showTitle: true,
  required: false,
  width: "400px",
  maxW: "836px",
  recommendTags: () => [],
  maxLength: 50,
  layout: TagInputLayout.VERTICAL,
  style: () => ({}),
  initTags: () => [],
});

const emit = defineEmits(["change"]);
const { t } = useI18n();

const tagInputDivRef = useTemplateRef<HTMLElement>("tagInputDivRef");
const placeholderRef = useTemplateRef<HTMLElement>("placeholderRef");
const inputDivRef = useTemplateRef<HTMLElement>("inputDivRef");

const {
  tags,
  tag,
  addTag,
  addRTag,
  deleteTag,
  scrollTagInputDivRef,
  handleInput,
} = useTagInput(props, emit, tagInputDivRef);

const tagInputRef = ref<HTMLDivElement>();

const isTagInputFocus = ref(false);

const tagInputClick = () => {
  console.log("tagInputDivClick;");
  isTagInputFocus.value = true;
  tagInputRef.value.focus();
  scrollTagInputDivRef();
};

onClickOutside(tagInputDivRef, () => {
  isTagInputFocus.value = false;
});

// 失焦添加标签;
const isBlurAddTag = ref(false);
const blurAddTag = () => {
  if (!tag.value || !tag.value.trim() || tags.value.length >= props.maxLength)
    return;
  if (tags.value.includes(tag.value.trim())) {
    useToast.warning(t("upload.modelTagTips"));
    return;
  }
  tags.value.push(tag.value.trim());
  tag.value = "";
  isBlurAddTag.value = true;
  setTimeout(() => {
    scrollTagInputDivRef();
    isBlurAddTag.value = false;
  }, 500);
};

const scrollTagInputHandler = () => {
  const scrollTop = tagInputDivRef.value?.scrollTop;
  const scrollLeft = tagInputDivRef.value?.scrollLeft;
  placeholderRef.value &&
    (placeholderRef.value.style.transform = `translate(${scrollLeft}px, ${scrollTop}px)`);
  const scrollHeight = tagInputDivRef.value?.scrollHeight || 0;
  const clientHeight = tagInputDivRef.value?.clientHeight || 0;
  const isBottom = Math.ceil(Number(scrollTop) + clientHeight) >= scrollHeight;
  inputDivRef.value?.classList.toggle("input-div-bottom", isBottom);
};

onMounted(() => {
  tagInputDivRef.value &&
    tagInputDivRef.value.addEventListener("scroll", scrollTagInputHandler);
});
</script>

<style lang="scss" scoped>
@use "./index.scss";
</style>
